// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"16146495","461":"4397f5ab"}[chunkId] + ".chunk.js";
};